module.exports = __webpack_public_path__ + "static/media/review1.2c4e6551.webp";